import { TicketDesignTypes, TicketDesignUsage } from "../../../models"
import { TicketDesignActions } from './ticket-design.actions'
import { BoxOfficeActions, EventActions } from '../../../actions';


export interface TicketDesignState  {
	ticketPrintTicketDesignUsage: TicketDesignUsage
	printAtHomeTicketDesignUsage: TicketDesignUsage,
	previewTicketPrintDesignBase64: string,
	previewPrintAtHomeDesignBase64: string,
	ticketPrintDesignUuid: string,
	printAtHomeTicketDesignUuid: string,
	showSpinner: boolean
}

const initialState: TicketDesignState = {
	ticketPrintTicketDesignUsage: null,
	printAtHomeTicketDesignUsage: null,
	previewTicketPrintDesignBase64: "",
	previewPrintAtHomeDesignBase64: "",
	ticketPrintDesignUuid: "",
	printAtHomeTicketDesignUuid: "",
	showSpinner: false
}

export const ticketDesignReducer = (state = initialState, action): TicketDesignState => {
	switch (action.type) {
		case EventActions.EVENT_LOADED: return initialState;
		case TicketDesignActions.TICKET_DESIGN_USAGES_BY_EVENT_UUID_LOADED: {
			let ticketPrintTicketDesignUsage: TicketDesignUsage = null
			let printAtHomeTicketDesignUsage: TicketDesignUsage = null
			action.payload.forEach(tdu => {
				if (tdu.ticketDesignType === TicketDesignTypes.TICKET_PRINT) {
					ticketPrintTicketDesignUsage = tdu
				} else if (tdu.ticketDesignType === TicketDesignTypes.PRINT_AT_HOME) {
					printAtHomeTicketDesignUsage = tdu
				}
			});
			return Object.assign({}, state,
				{
					ticketPrintTicketDesignUsage: ticketPrintTicketDesignUsage,
					printAtHomeTicketDesignUsage: printAtHomeTicketDesignUsage
				})
		}

		case TicketDesignActions.TICKET_DESIGN_UPLOADED: {
			if (action.payload.ticketDesignType === TicketDesignTypes.TICKET_PRINT) {
				return Object.assign({}, state, {
					ticketPrintDesignUuid: action.payload.ticketDesign.content,
					ticketPrintTicketDesignUsage: null
				})
			}else if (action.payload.ticketDesignType === TicketDesignTypes.PRINT_AT_HOME) {
				return Object.assign({}, state, {
					printAtHomeTicketDesignUuid: action.payload.ticketDesign.content,
					printAtHomeTicketDesignUsage: null
				})
			} else {
				return state
			}
		}

		case TicketDesignActions.TICKET_DESIGN_USAGE_SAVED: {
			if (action.payload.ticketDesignType === TicketDesignTypes.TICKET_PRINT) {
				return Object.assign({}, state, {
					ticketPrintTicketDesignUsage: action.payload
				})
			}
			else if (action.payload.ticketDesignType === TicketDesignTypes.PRINT_AT_HOME) {
				return Object.assign({}, state, {
					printAtHomeTicketDesignUsage: action.payload
				})
			} else {
				return state
			}
		}

		case TicketDesignActions.TICKET_PREVIEW_IMAGE_LOADED: {
			if (action.payload.ticketDesignType === TicketDesignTypes.TICKET_PRINT) {
				return Object.assign({}, state, {
					previewTicketPrintDesignBase64: action.payload.base64Preview
				})
			}else if (action.payload.ticketDesignType === TicketDesignTypes.PRINT_AT_HOME) {
				return Object.assign({}, state, {
					previewPrintAtHomeDesignBase64: action.payload.base64Preview
				})
			} else {
				return state
			}
		}

		case TicketDesignActions.TICKET_DESIGN_TICKET_PRINT_DELETED: {
			return Object.assign({}, state, {
				previewTicketPrintDesignBase64: "",
				ticketPrintDesignUuid: ""
			})
		}

		case TicketDesignActions.TICKET_DESIGN_PRINT_AT_HOME_DELETED: {
			return Object.assign({}, state, {
				previewPrintAtHomeDesignBase64: "",
				printAtHomeTicketDesignUuid: ""
			})
		}

		case TicketDesignActions.TICKET_DESIGN_USAGE_TICKET_PRINT_DELETED: {
			return Object.assign({}, state, {
				ticketPrintTicketDesignUsage: null,
				previewTicketPrintDesignBase64: "",
				ticketPrintDesignUuid: ""
			})
		}

		case TicketDesignActions.TICKET_DESIGN_USAGE_PRINT_AT_HOME_DELETED: {
			return Object.assign({}, state, {
				printAtHomeTicketDesignUsage: null,
				previewPrintAtHomeDesignBase64: "",
				printAtHomeTicketDesignUuid: ""
			})
		}

		case TicketDesignActions.SHOW_SPINNER: {
			return Object.assign({}, state, {
				showSpinner: true
			})
		}

		case TicketDesignActions.HIDE_SPINNER: {
			return Object.assign({}, state, {
				showSpinner: false
			})
		}

		case BoxOfficeActions.CLEAR_EVENTSERVER_STATE:
			return initialState;

		default: return state
	}

}

/*@Effect foo = this.updates$
	.flatMap(action => {
		this.ticketDdesignApi.getPreview(action.tdu._links.preview.href))
			.map(resp => new PreviewLoadedACtion(action.tdu.getDEsignType,resp.base64))
	})

*/



// WEBPACK FOOTER //
// ./src/app/components/event-components/ticket-designs/ticket-design.reducer.ts